import {Badge, Button, Image, NavLink } from "react-bootstrap";
//const actionsOptions=[{value: 'gotolisting', label: 'Go to Listing' }];

export function formatImage(url) {
  return <Image src={url} alt="img" rounded />;
}

export function formatStatus(status) {
  const cls = status.replace(" ", "-");
  return <Badge className={"status "+cls}>{status}</Badge>;
}

export function formatActionsWithAnalytics(product, onOpenAnalytics) {
  const marketplaces = JSON.parse(localStorage.getItem("marketplaceOptions"));
  const mtpl = localStorage.getItem("selectedMarketplace");
  const domain = marketplaces?.find((m) => m.value === mtpl)?.domain;

  return (
    <div className="dropdown menu-actions">
      <button
        className="btn btn-secondary btn-sm dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        onClick={(e) => e.stopPropagation()}
      >
        <i className="fa-solid fa-ellipsis-vertical"></i>
      </button>

      <ul className="dropdown-menu dropdown-menu-dark dropdown-menu-end sm">
        <li>
          <button
            type="button"
            className="dropdown-item"
            onClick={(e) => {
              e.stopPropagation();
              onOpenAnalytics?.(product);
            }}
          >
            <i className="fas fa-chart-column"></i> View analytics
          </button>
        </li>

        <li>
          <NavLink
            className="dropdown-item"
            href={`https://www.${domain}/dp/${product.asin}`}
            target="_blank"
          >
            <i className="fa-brands fa-amazon"></i> Go to Listing
          </NavLink>
        </li>

        <li>
          <NavLink
            className="dropdown-item"
            href={`https://app.profitpalms.com/products/dashboard?product=${product.asin}`}
            target="_blank"
          >
            <i className="fas fa-tachometer-alt"></i> Go to APP Dashboard
          </NavLink>
        </li>
      </ul>
    </div>
  );
}

export function formatActions(product) {
  const marketplaces = JSON.parse(localStorage.getItem("marketplaceOptions"));
  const mtpl=localStorage.getItem("selectedMarketplace");

  return (
    <div className="dropdown menu-actions">
      <button className="btn btn-secondary btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" onClick={e => e.stopPropagation()}>
          <i className="fa-solid fa-ellipsis-vertical"></i>
      </button>
      <ul className="dropdown-menu dropdown-menu-dark dropdown-menu-end sm">
        <li>
          <NavLink className="dropdown-item" href={'https://www.'+marketplaces.find((m) => m.value === mtpl)?.domain+'/dp/'+product.asin} target="_blank">
            <i className="fa-brands fa-amazon"></i> Go to Listing</NavLink>
        </li>
        <li>
          <NavLink className="dropdown-item" href={'https://app.profitpalms.com/products/dashboard?product='+product.asin} target="_blank">
            <i className="fas fa-tachometer-alt"></i> Go to APP Dashboard</NavLink>
        </li>

      </ul>
    </div>
  );
}


export function formatProdInfo(item) {
  return (
    <>
    {item.asin}
    {item.sku ? '<br/>'+item.sku : ''}
    {item.fnsku ? '<br/>'+item.fnsku : '' }
    </>
  );
}
